export const environment = {
  production: false,
  enableLogging: true,
  name: "DEV",
  apiBaseUrl: "https://dev-fleetweb.vwfs.se/api"
};
